import React from 'react';
import './LoadingOverlay.css';

export const LoadingOverlay = ({ visible, message = 'Loading...' }) => {
    if (!visible) return null;

    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <div className="loading-spinner"></div>
                <p className="loading-message">{message}</p>
            </div>
        </div>
    );
};

export default LoadingOverlay;
